import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { LoginNextStep } from '../api/login/login.api';

interface LoginFlow {
  loginError: boolean;
  dobError: boolean;
  pinError: boolean;
}

export interface Login {
  loginFlow: LoginFlow;
  lockOutMessage: string;
  checkoutAppState: string;
  multiCardUser: boolean;
  nextStep: LoginNextStep;
  eligiblePhoneNumber: string;
}

const initialState: Login = {
  loginFlow: {
    loginError: false,
    dobError: false,
    pinError: false,
  },
  lockOutMessage: '',
  checkoutAppState: '',
  multiCardUser: false,
  nextStep: 'verifyOTP',
  eligiblePhoneNumber: '',
};

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setLoginFlow: (state, action: PayloadAction<LoginFlow>) => {
      state.loginFlow = action.payload;
    },
    setPinError: (state, action: PayloadAction<boolean>) => {
      state.loginFlow.pinError = action.payload;
    },
    setLockOutMessage: (state, action: PayloadAction<string>) => {
      state.lockOutMessage = action.payload;
    },
    setCheckoutAppState: (state, action: PayloadAction<string>) => {
      state.checkoutAppState = action.payload;
    },
    setMultiCardUser: (state, action: PayloadAction<boolean>) => {
      state.multiCardUser = action.payload;
    },
    setNextStep: (state, action: PayloadAction<LoginNextStep>) => {
      state.nextStep = action.payload;
    },
    setEligiblePhoneNumber: (state, action: PayloadAction<string>) => {
      state.eligiblePhoneNumber = action.payload;
    },
  },
});

export const {
  setLoginFlow,
  setLockOutMessage,
  setCheckoutAppState,
  setMultiCardUser,
  setNextStep,
  setEligiblePhoneNumber,
  setPinError,
} = loginSlice.actions;
export default loginSlice.reducer;
